import { useQuery } from '@tanstack/react-query';

import { apiBaseUrl } from '../../../config';
import queryKeys from '../../queryKeys';
import { FlightOperationNotificationClient } from '../../clients';

const FonClient = new FlightOperationNotificationClient(apiBaseUrl);

function useGetFlightOperationNotificationDrafts() {
  return useQuery({
    queryKey: [queryKeys.FlightOperationNotification.Drafts],
    queryFn: () => FonClient.getDrafts(),
  });
}

export default useGetFlightOperationNotificationDrafts;
